document.addEventListener('DOMContentLoaded', function() {
  // 見出しを取得
  const headings = document.querySelectorAll('h2, h3');
  const tocContainer = document.getElementById('toc-container');

  if (!tocContainer || headings.length === 0) return; // 目次コンテナがない場合は処理を終了

  // 目次を生成
  const toc = document.createElement('ul');
  toc.style.listStyleType = 'none';
  toc.style.padding = '0';

  let isFirstH2 = true;  // 最初のh2をスキップするためのフラグ

  headings.forEach((heading, index) => {
      // 最初のh2をスキップ
      if (heading.tagName.toLowerCase() === 'h2' && isFirstH2) {
          isFirstH2 = false;
          return;
      }

      // 特定の見出しをスキップ
      const skipHeadings = ['カートにアイテムが追加されました', 'Contents'];
      if (skipHeadings.includes(heading.textContent)) {
          return;
      }

      // 空の見出しやドットのみの見出しをスキップ
      if (!heading.textContent.trim() || heading.textContent.trim() === '・') {
          return;
      }

      const li = document.createElement('li');
      const a = document.createElement('a');

      // 見出しにIDを設定
      heading.id = `section-${index}`;

      // リンクを設定
      a.href = `#section-${index}`;
      a.textContent = heading.textContent;

      // クリックイベントを追加（スムーズスクロール）
      a.addEventListener('click', function(e) {
          e.preventDefault();
          const targetElement = document.getElementById(`section-${index}`);
          if (!targetElement) return;

          const offset = 90; // スクロール位置の調整値（ピクセル）
          const targetPosition = targetElement.getBoundingClientRect().top + window.pageYOffset - offset;
          window.scrollTo({
              top: targetPosition,
              behavior: 'smooth' // スムーズスクロール
          });
      });

      // h3の場合、インデントを追加
      if (heading.tagName.toLowerCase() === 'h3') {
          li.classList.add('h3-item');
      }

      li.appendChild(a);
      toc.appendChild(li);
  });

  tocContainer.appendChild(toc);
});
